import { Button, Stack, type SxProps, type Theme } from '@mui/material';
import {
  Dialog,
  DialogHeader,
  DialogSubTitle,
  DialogTitle,
} from 'src/components/appDialog/index.styles';

interface AdminPaymentConfirmProps {
  open: boolean;
  amount: number;
  onClose: () => void;
  onConfirm: () => void;
  sx?: SxProps<Theme>;
}

// Admins land here when checking out a real (non-gems) cart. There's no test
// cap any more — this is the deliberate gate so an admin doesn't fire a live
// Razorpay charge by reflex while exercising the store.
const AdminPaymentConfirm = ({
  open,
  amount,
  onClose,
  onConfirm,
  sx,
}: AdminPaymentConfirmProps) => (
  <Dialog open={open} onClose={onClose} sx={sx}>
    <DialogHeader></DialogHeader>
    <Stack sx={{ alignItems: 'center', gap: '4px' }}>
      <DialogTitle sx={{ textAlign: 'center' }}>
        Confirm real payment
      </DialogTitle>
      <DialogSubTitle sx={{ textAlign: 'center' }}>
        You&apos;re signed in as an admin. This is a live ₹{amount} charge on
        your own account — not a test. Continue only if you mean to pay.
      </DialogSubTitle>
    </Stack>
    <Stack direction="row" sx={{ gap: '12px', width: '100%' }}>
      <Button
        onClick={onClose}
        variant="outlined"
        fullWidth
        sx={{ borderRadius: '12px', py: '8px' }}
      >
        Cancel
      </Button>
      <Button
        onClick={onConfirm}
        variant="contained"
        fullWidth
        sx={{ borderRadius: '12px', py: '8px' }}
      >
        Pay ₹{amount}
      </Button>
    </Stack>
  </Dialog>
);

export default AdminPaymentConfirm;
